var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4457 21.4913C16.7131 21.4913 20.9832 17.2212 20.9832 11.9538C20.9832 6.68635 16.7131 2.41627 11.4457 2.41627C6.17829 2.41627 1.9082 6.68635 1.9082 11.9538C1.9082 17.2212 6.17829 21.4913 11.4457 21.4913Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.122 18.63L16.6914 17.1994M4.76953 5.27752L6.20016 6.70814",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67773 15.2919L7.08642 13.8613M7.08642 13.8613L8.58523 8.61564L10.0841 13.8613M7.08642 13.8613H10.0841M10.4927 15.2919L10.0841 13.8613M16.6921 11.9538C16.6921 14.3381 14.9839 15.2919 12.8771 15.2919V8.61564C14.9839 8.61564 16.6921 9.56939 16.6921 11.9538Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAds);
export default __webpack_public_path__ + "static/media/ads.c606bdcdc9f70657600e06d8cd91396b.svg";
export { ForwardRef as ReactComponent };